import { render, staticRenderFns } from "./customizeSetting.vue?vue&type=template&id=635fffea&scoped=true&"
import script from "./customizeSetting.vue?vue&type=script&lang=js&"
export * from "./customizeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fffea",
  null
  
)

export default component.exports